<template>
    <div class="wrapper">
        <nav class="main-header navbar navbar-expand-md navbar-dark bg-dark navbar-white">
            <div class="container">
                <a href="/bolsistas" class="navbar-brand">Sistema Unificado de Bolsas</a>
                <button 
                    class="navbar-toggler order-1" 
                    type="button" 
                    data-toggle="collapse" 
                    data-target="#navbarCollapse" 
                    aria-controls="navbarCollapse" 
                    aria-expanded="false" 
                    aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div id="navbarCollapse" class="collapse navbar-collapse order-3">
                    <ul class="navbar-nav">
                        <li class="nav-item">
                            <router-link to="/" class="nav-link">Início</router-link>
                        </li>
                        <li class="nav-item" v-if="isAdmin">
                            <router-link to="/upload" class="nav-link">Envio</router-link>
                        </li>
                        <li class="nav-item" v-if="isAdmin">
                            <router-link to="/avaliacoes" class="nav-link">Avaliações</router-link>
                        </li>
                    </ul>
                </div>
                <ul class="order-1 order-md-3 navbar-nav navbar-no-expand ml-auto">
                    <li class="nav-item"> 
                        <a href="" @click.prevent="logout" class="nav-link">
                            <font-awesome-icon icon="sign-out-alt" />
                            Sair
                        </a>
                    </li>
                </ul>
            </div>
        </nav>
        <div class="content-wrapper">
            <router-view></router-view>
        </div>

        <Footer />
    </div>
</template>

<script>
import Footer from '@/components/Footer'

export default {
    name: 'Default',
    components: {Footer},
    computed:{
        isAdmin: function () {
            let roles = localStorage.getItem('roles')

            if (roles.includes('ADMINISTRATORS')) {
                return true
            }
            return false
        }
    },
    methods:{
        logout () {
            localStorage.removeItem('token')
            localStorage.removeItem('roles')
            window.location = process.env.VUE_APP_CAS_LOGOUT_URL
        }
    }
}
</script>